export const hapticMixin = {
  data() {
    return {
      hapticInputRef: null,
      hapticLabelRef: null,
      isIOS: false,
      hapticDuration: 5
    };
  },
  mounted() {
    this.isIOS = this.detectiOS();
    this.initHaptic();
  },
  beforeUnmount() {
    this.cleanupHaptic();
  },
  methods: {
    detectiOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    initHaptic() {
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.id = `haptic-switch-${this._uid || Math.random()}`;
      input.setAttribute('switch', '');
      input.style.display = 'none';
      document.body.appendChild(input);
      this.hapticInputRef = input;

      const label = document.createElement('label');
      label.htmlFor = input.id;
      label.style.display = 'none';
      document.body.appendChild(label);
      this.hapticLabelRef = label;
    },
    cleanupHaptic() {
      if (this.hapticInputRef) {
        document.body.removeChild(this.hapticInputRef);
      }
      if (this.hapticLabelRef) {
        document.body.removeChild(this.hapticLabelRef);
      }
    },
    triggerHaptic(duration) {
      const vibrateDuration = duration || this.hapticDuration;
      if (!this.isIOS && navigator?.vibrate) {
        navigator.vibrate(vibrateDuration);
      } else {
        this.hapticLabelRef?.click();
      }
    }
  }
};